import { useCallback } from 'react';

import { useIsDirty } from '../stores/dirty';
import { requestUnsavedChangesConfirmation } from '../stores/dialog';

export const useConfirmIfDirty = () => {
  const isDirty = useIsDirty();
  return useCallback(
    (action: () => void) => {
      if (!isDirty) {
        action();
        return;
      }
      requestUnsavedChangesConfirmation(action);
    },
    [isDirty],
  );
};
